import { render } from "./Builder.vue?vue&type=template&id=58ff7f4d"
import script from "./Builder.vue?vue&type=script&lang=ts"
export * from "./Builder.vue?vue&type=script&lang=ts"
script.render = render

export default script